import React, { CSSProperties, useEffect, useState } from 'react';
import styled from 'styled-components';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { IconButton } from '@mui/material';
import { toast } from 'react-toastify';
import { Row } from 'saladsoft-primitive';

export const CountButton = ({
  count,
  maxCount,
  useZero,
  style,
  onChange,
}: {
  count: number;
  maxCount: number;
  useZero?: boolean;
  style?: CSSProperties;
  onChange: (count: number) => void;
}) => {
  const [guestCount, setGuestCount] = useState<number>(0);
  const [maxCount2, setMaxCount] = useState<number>(1);

  const handleDecrease = () => {
    setGuestCount((prev) => {
      if (prev > (useZero ? 0 : 1)) {
        onChange?.(prev - 1);
        return prev - 1;
      } else {
        return prev;
      }
    });
  };

  const handleIncrease = () => {
    setGuestCount((prev) => {
      if (prev < maxCount2) {
        onChange?.(prev + 1);
        return prev + 1;
      } else {
        toast('The maximum quantity has been exceeded.'), { type: 'info' };
        return prev;
      }
    });
  };

  useEffect(() => {
    if (count) setGuestCount(count);
  }, [count]);

  useEffect(() => {
    if (maxCount) setMaxCount(maxCount);
  }, [maxCount]);

  return (
    <Container style={style}>
      <Row width={'100%'} justifyContent="space-between">
        <IconButton onClick={handleDecrease}>
          <RemoveIcon />
        </IconButton>
        <div>{guestCount}</div>
        <IconButton onClick={handleIncrease}>
          <AddIcon />
        </IconButton>
      </Row>
    </Container>
  );
};

const Container = styled.div`
  padding: 0 3px;
  display: flex;
  width: 163px;
  height: 42px;
  flex-shrink: 0;
  border-radius: 44.5px;
  border: 1px solid #555;
`;
